import React from "react";
import { withRouter } from "react-router-dom";
import Addextraitemform from "./components/Addextraitemform";
function Addextraitems() {
  return <Addextraitemform></Addextraitemform>;
}
export default withRouter(Addextraitems);
